import { render, staticRenderFns } from "./simCancelRecord.vue?vue&type=template&id=003067ce&scoped=true&"
import script from "./simCancelRecord.vue?vue&type=script&lang=js&"
export * from "./simCancelRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003067ce",
  null
  
)

export default component.exports